import { GenderType, PhoneNumberType } from '../interfaces/document';
import { TelephoneEntry } from '../interfaces/referral';

/**
 * Formats gender code to human-readable display string
 * @param gender - Gender code (M, F, O)
 * @returns Formatted gender display string or null if not provided
 */
export const formatGenderDisplay = (gender?: string): string | null => {
  if (!gender) {
    return null;
  }
  switch (gender) {
    case GenderType.Female:
      return 'Female';
    case GenderType.Male:
      return 'Male';
    case GenderType.Other:
      return 'Other';
    default:
      return gender;
  }
};

/**
 * Extracts phone number by type from telephone array
 * @param type - Type of phone number (cell, home, other, work)
 * @param telephone - Array of telephone entries
 * @returns Phone number string or null if not found
 */
export const getPhoneNumberByType = (
  type: PhoneNumberType,
  telephone?: TelephoneEntry[],
): string | null => {
  if (!telephone) {
    return null;
  }
  return telephone.find((t) => t.type === type)?.number || null;
};

/**
 * Formats patient name to title case
 * @param name - Patient name string
 * @returns Formatted patient name or original if empty/unknown
 */
export const formatPatientName = (name?: string): string => {
  if (!name || name === 'Unknown') {
    return name || 'Unknown';
  }
  return name
    .split(' ')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
};
